module.exports = __webpack_public_path__ + "static/media/ecs-website-design.214b2cb5.jpg";